import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'default' })
export class DefaultPipe implements PipeTransform {
  transform(value: unknown): unknown {
    return value || 'N/A';
  }
}
